import { LoadScanningRequest } from "../../models/requestModels/loadScanningRequest";
import { GeofenceRequest } from "../../models/requestModels/rtsRequest";
import { axiosRequests } from "../axiosRequest";

export const VehicleLoadScanAgent = {
  checkGeofence : (geofenceReq : GeofenceRequest) => 
    axiosRequests.post<any>(`/fdc-commandops/liv/check/geofence`, geofenceReq),
  fetchDriverEmailsByStore : (storeId : String, long: string, lat: string) => 
    axiosRequests.get<any>(`/fdc-commandops/liv/fetch/driver-emails?store_id=${storeId}&long=${long}&lat=${lat}`),
  fetchRecevingsForCurrentDay : (driverId : String, storeId : String, long: string, lat: string) =>
    axiosRequests.get<any>(`/fdc-commandops/liv/fetch/receivings?driver_id=${driverId}&store_id=${storeId}&long=${long}&lat=${lat}`),
  updateRecevings : (livRequest: LoadScanningRequest) => 
    axiosRequests.post<any>(`/fdc-commandops/liv/update/receivings`, livRequest),
};
